<template>
  <v-container fluid style="height: calc(100vh - 64px)">
    <v-row style="height:100%">
      <v-col cols="12" md="6" class="pt-0" style="height: 100%">
        <v-card ref="content" height="100%">
          <v-row style="height:55px; margin-bottom: 10px;" no-gutters>
            <v-col class="pa-3" cols="6">
              <span class="headline">{{ $i18n.t('offer.attributes.title') }}</span>
            </v-col>
            <v-col class="pa-3" cols="6">
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                :title="$i18n.t(`parcels.table.copy`)"
                @click="copyParcelDialog()"
              >
                <v-icon dark>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                @click="isNewEntity ? postNewParcel() : editParcel()"
                :title="
                  isNewEntity
                    ? $i18n.t(`default.save`)
                    : $i18n.t(`default.saveEditing`)
                "
              >
                <v-icon dark>mdi-content-save-outline</v-icon>
              </v-btn>
              <v-btn
                class="float-right mr-1"
                fab
                dark
                small
                color="primary"
                @click="$router.push('/parcels')"
                :title="$i18n.t(`parcels.backToParcels`)"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="attributes" v-if="isReady">
            <v-col>
              <div style v-bar>
                <v-expansion-panels accordion>
                  <v-expansion-panel v-for="(value, key) in attributes" :key="key">
                    <v-expansion-panel-header>{{ $i18n.t(`offer.categories.${key}`) }}</v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-1">
                      <v-form>
                        <template v-for="attribute of value">
                          <component
                            v-if="fieldComponent(attribute)"
                            :is="fieldComponent(attribute)"
                            :key="attribute.name"
                            :attribute="attribute"
                            :canEdit="canEdit"
                            v-model="attribute.value"
                          />
                          <v-row v-else :key="attribute.name">
                            <LabelCol
                              v-if="attribute.name !== 'cena_m'"
                              :attribute="attribute"
                              :cols="4"
                            />
                            <v-spacer v-if="attribute.name ==='cena_m'"></v-spacer>
                            <v-col v-if="attribute.type === 'computed'" cols="8" class="py-0">
                              <computed-row :attribute="attribute" :label-cols="0" :value-cols="12" :values="flatProperties"/>
                            </v-col>
                            <v-col v-if="attribute.type === 'disabled'" cols="8" class="pa-0">
                              <v-text-field
                                v-model="attribute.value"
                                disabled
                                :readonly="!canEdit"
                                outlined
                              />
                            </v-col>
                            <v-col v-if="attribute.type === 'boolean'" cols="8" class="pa-0">
                              <v-select
                                :attach="true"
                                :readonly="!canEdit"
                                v-model="attribute.value"
                                :items="dicts.boolean"
                                :item-text="$i18n.locale"
                                item-value="bool"
                                outlined
                              />
                            </v-col>
                            <v-col v-if="attribute.type === 'price'" cols="8" class="pa-0">
                              <price-field
                                v-if="attribute.name === 'cena_zakupu'"
                                v-model="attribute.value"
                                :label="$i18n.t('default.pln')"
                                :outlined="true"
                                :readonly="!canEdit"
                              />
                              <v-text-field
                                v-if="attribute.name === 'cena_zakupu'"
                                readonly
                                outlined
                                v-model.number="priceEur"
                                :label="$i18n.t('default.eur')"
                                type="text"
                              />
                              <price-field
                                v-if="attribute.name === 'cena_m'"
                                v-model="pricePLNM"
                                :label="$i18n.t('default.plnm2')"
                                :outlined="true"
                                :readonly="!canEdit"
                              />
                              <v-text-field
                                v-if="attribute.name === 'cena_m'"
                                readonly
                                outlined
                                v-model.number="priceEurM"
                                :label="$i18n.t('default.eurm2')"
                                type="text"
                              />
                            </v-col>
                            <Multiselect
                              v-if="attribute.type === 'multiselect'"
                              :attribute="attribute"
                              :canEdit="canEdit"
                              :dicts="dicts"
                            />
                            <KwNumberField
                              v-if="attribute.type === 'nr_kw'"
                              :attribute="attribute"
                              :canEdit="canEdit"
                            />
                            <SoilClass
                              v-if="attribute.type === 'kvp'"
                              :canEdit="canEdit"
                              v-model="attribute.value"
                            ></SoilClass>
                            <PumField
                              v-if="attribute.type === 'pum'"
                              :canEdit="canEdit"
                              v-model="attribute.value"
                            />
                            <template v-if="attribute.type == 'select'">
                              <v-col cols="8" class="pa-0 pr-1">
                                <v-row
                                  v-if="
                                    attribute.value &&
                                      attribute.value.en == 'other'
                                  "
                                >
                                  <v-col cols="12" class="py-0">
                                    <v-text-field
                                      label="Inna wartość"
                                      :readonly="!canEdit"
                                      v-model="attribute.value['other']"
                                      outlined
                                    />
                                  </v-col>
                                </v-row>
                              </v-col>
                            </template>
                          </v-row>
                        </template>
                      </v-form>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="pt-0" style="height: 100%">
        <v-row style="height: 50%">
          <v-col cols="12" style="height:100%" class="pt-0">
            <v-card height="100%">
              <v-row style="height:100%" no-gutters ref="parcels">
                <v-col class="pa-1" style="height:100%">
                  <div style="height:100%;width:100%">
                    <ParcelsMap
                      ref="map"
                      :single-parcel="true"
                      :has-filter="false"
                      @updateProperties="updateProperties"
                      @updateGeometry="updateGeometry"
                      @openRemoveGeometryDialog="openRemoveGeometryDialog"
                      :parcels="selectedParcel ? [selectedParcel] : []"
                    />
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row style="height:50%" class="parcels" ref="parcels" v-if="!isNewEntity">
          <v-col cols="12" style="height:100%" class="pb-0">
            <v-card height="100%">
              <v-row style="height:65px" no-gutters>
                <v-col class="pa-3" cols="10">
                  <v-tabs v-model="activeTab" ref="tabs_1">
                    <v-tab>{{ $i18n.t(`offer.categories.comments`) }}</v-tab>
                    <v-tab>{{ $i18n.t(`offer.categories.attachments`) }}</v-tab>
                  </v-tabs>
                  <v-btn
                    class="btn--add"
                    fab
                    dark
                    small
                    color="primary"
                    :title="activeTab === 0 ? $i18n.t('offer.comments.addComment'): $i18n.t('offer.attachments.upload')"
                    @click="addTableElement"
                  >
                    <v-icon dark>mdi-plus</v-icon>
                  </v-btn>
                  <v-btn
                    class="btn--phone"
                    fab
                    dark
                    small
                    v-show="activeTab === 0"
                    color="primary"
                    :title="lastContactTitle"
                    @click="addLastContact"
                  >
                    <v-icon dark>mdi-cellphone-android</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row style="height: calc(100% - 65px); margin-top: 5px;" no-gutters>
                <v-col class="pa-1" style="height:100%">
                  <div style="height:100%;width:100%" v-show="activeTab == 0">
                    <CommentsTable :entity-id="entityID" entity-type="parcel" />
                  </div>
                  <div style="height:100%;width:100%" v-show="activeTab == 1">
                    <AttachmentsTable :entity-id="entityID" entity-type="parcel" />
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <ConfirmDialog
      v-if="confirmDialogLoaded"
      :dialog="confirmDialogVisible"
      @success="confirmDelete()"
      @cancel="confirmDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`offer.${deleteFrom}.deleteHeader`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`offer.${deleteFrom}.deleteBody`) }}</p>
      </template>
    </ConfirmDialog>
    <ConfirmDialog
      v-if="copyDialogLoaded"
      :dialog="copyDialogVisible"
      @success="copyParcel()"
      @cancel="copyDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`parcels.copyDialog.title`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`parcels.copyDialog.contentQuestion`) }}</p>
      </template>
    </ConfirmDialog>
    <ConfirmDialog
      :dialog="isConfirmExitVisible"
      @success="confirmExit"
      @cancel="isConfirmExitVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`default.confirmExitHeader`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`default.confirmExitBody`) }}</p>
      </template>
    </ConfirmDialog>
    <ConfirmDialog
      v-if="removeGeometryDialogLoaded"
      :dialog="removeGeometryDialogVisible"
      @success="removeGeometry()"
      @cancel="removeGeometryDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.removeGeometry`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`dialog.content.removeGeometry`) }}</p>
      </template>
    </ConfirmDialog>
    <!-- <ConfirmDialog
      v-if="uldkDialogLoaded"
      :dialog="uldkDialogVisible"
      @success="confirmedUldkParcel()"
      @cancel="uldkDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`dialog.header.changeParcelGeom`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`dialog.content.changeParcelGeom`) }}</p>
      </template>
    </ConfirmDialog>-->
    <DefaultDialog
      v-if="copyDoneDialogLoaded"
      :dialog="copyDoneDialogVisible"
      @cancel="copyDoneDialogVisible = false"
    >
      <template v-slot:header>
        <h1>{{ $i18n.t(`parcels.copyDialog.title`) }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $i18n.t(`parcels.copyDialog.contentDone`) }}</p>
      </template>
    </DefaultDialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import ParcelsMap from '@/components/parcels/ParcelsMap';
import AttachmentsTable from '@/components/AttachmentsTable';
import CommentsTable from '@/components/CommentsTable';
import Multiselect from '@/components/Multiselect';
import LabelCol from '@/components/fields/LabelCol';
import KwNumberField from '@/components/KwNumberField';
import SoilClass from '@/components/SoilClass';
import PriceField from '@/components/fields/PriceField';
import ComputedRow from '@/components/fields/ComputedRow';

import { DICTS } from '@/dicts';
import { getFieldComponent } from '@/components/fields/fieldComponents';
// mixins
import pricesMixin from '@/mixins/pricesMixin';
import entityBasicMixin from '@/mixins/entityBasicMixin';
import tabsMixin from '@/mixins/tabsMixin';

export default {
  mixins: [entityBasicMixin, pricesMixin, tabsMixin],
  components: {
    ParcelsMap,
    AttachmentsTable,
    CommentsTable,
    Multiselect,
    LabelCol,
    KwNumberField,
    SoilClass,
    PriceField,
    ComputedRow,
    PumField: () => import('@/components/fields/PumField'),
    MapLegendDialog: () => import('@/components/dashboard/MapLegendDialog'),
    ConfirmDialog: () => import('@/components/ConfirmDialog'),
    DefaultDialog: () => import('@/components/DefaultDialog')
  },
  data: () => ({
    attributesCopy: {},
    copyDialogLoaded: false,
    copyDialogVisible: false,
    copyDoneDialogLoaded: false,
    copyDoneDialogVisible: false,
    uldkDialogLoaded: false,
    uldkDialogVisible: false,

    activeTab: undefined,
    attributes: undefined,
    attachments: [],
    tableLoading: true,
    comments: [],

    isCommentAttachmentModal: false,
    isLegendLoaded: false,
    isLegendVisible: false,
    confirmDialogLoaded: false,
    confirmDialogVisible: false,
    canEdit: false,
    deleteFrom: undefined,
    selectedItemIndex: undefined,
    isParcelEditing: false,
    zoom: undefined,
    center: undefined,
    parcels: [],
    selectedParcel: undefined,

    removeGeometryDialogLoaded: false,
    removeGeometryDialogVisible: false,

    isReady: false,
    valuationClasses: ['I', 'II', 'IIIa', 'IIIb', 'IVa', 'IVb', 'V', 'VI', 'VIz'],
    emptyValuationClasses: [],
    I: '',
    II: '',
    IIIa: '',
    IIIb: '',
    IVa: '',
    IVb: '',
    V: '',
    VI: '',
    VIz: '',
    selectedValuationClass: undefined,
    dicts: DICTS,
    confirmExitTo: undefined,
    isConfirmExitVisible: false,
    isEdited: false
  }),
  watch: {
    users(users) {
      this.dicts.kontakt_cbre = users;
    }
  },
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    user() {
      return this.$store.getters.getUser;
    },
    mapZoom() {
      return this.$store.getters.getZoom;
    },
    mapCenter() {
      return this.$store.getters.getCenter;
    },
    flatProperties() {
      let flatProperties = {};
      for (let group in this.attributes) {
        this.attributes[group].forEach(property => {
          flatProperties[property.name] = property;
        });
      }
      return flatProperties;
    },
    lastContactTitle() {
      const date = new Date().toLocaleString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
      return this.$i18n.t('offer.comments.addLastContact') + ': ' + date;
    }
  },

  methods: {
    addLastContact() {
      this.$root.$emit('addLastContactComment');
    },
    fieldComponent(attribute) {
      if (attribute.name === 'wojewodztwo') {
        return false;
      }
      if (attribute.name === 'powiat') {
        return false;
      }
      if (attribute.name === 'gmina') {
        return false;
      }

      return getFieldComponent(attribute);
    },
    copyParcelDialog() {
      this.copyDialogLoaded = true;
      this.copyDialogVisible = true;
    },
    copyParcel() {
      this.copyDialogVisible = false;
      this.$store.dispatch('copyParcel', this.entityID).then(r => {
        this.$router.push({ name: 'parcel', params: { id: r.data.parcels } });
        this.copyDoneDialogLoaded = true;
        this.copyDoneDialogVisible = true;
      });
    },

    addTableElement() {
      if (this.activeTab === 0) {
        this.$root.$emit('openCommentsDialog');
      } else {
        this.$root.$emit('openAttachmentsDialog');
      }
    },
    addedElement(data) {
      this[this.addingElement][this.addingElement].push(data);
      this.isCommentAttachmentModal = false;
    },
    changeBaselayer(baselayer) {
      this.$refs.map.changeBaselayer(baselayer);
    },
    downloadAttachment(id) {
      this.$store.dispatch('downloadAttachment', id).then(r => {
        if (r.status === 200) {
          const blob = new Blob([r.data], { type: r.data.type });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = r.headers.attachment_filename; //<--- Brakuje nazwy pliku, request go nie zwraca. Plik się pobiera ale ma nazwę undefined.
          link.click();
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.offers.errorDB'));
        }
      });
    },

    // setValue(value) {
    //   this.$emit('input', Number(value));
    // },
    saveComment(payload) {
      this.axios
        .post('/comments', {
          entity_id: this.attributes.id,
          entity_type: 'parcel',
          datetime: payload.datetime,
          user: payload.user,
          content: payload.content,
          status: payload.status
        })
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          console.error(e);
          return e;
        });
    },
    saveAttachment(payload) {
      this.axios
        .post('/files', {
          entity_id: this.attributes.id,
          entity_type: 'parcel',
          datetime: payload.datetime,
          user: payload.user,
          pl: payload.pl,
          en: payload.en
        })
        .then(r => {
          if (r) {
            return r;
          }
        })
        .catch(e => {
          console.error(e);
          return e;
        });
    },
    openRemoveGeometryDialog() {
      this.removeGeometryDialogLoaded = true;
      this.removeGeometryDialogVisible = true;
    },
    removeGeometry() {
      this.removeGeometryDialogVisible = false;
      this.selectedParcel.geometry = null;
      this.$refs.map.removedGeometry();
    },
    closeCommAttachModal() {
      this.isCommentAttachmentModal = false;
    },
    confirmDelete() {
      this[this.deleteFrom][this.deleteFrom].splice(this.selectedItemIndex, 1);
      this.confirmDialogVisible = false;
    },
    deleteRow(table, idx) {
      this.confirmDialogLoaded = true;
      this.confirmDialogVisible = true;
      this.deleteFrom = table;
      this.selectedItemIndex = idx;
    },
    editComment() {},

    saveEditing(table, idx) {
      let payload = this[table][table][idx];
      this.$store.dispatch(`${table}Edit`, payload).then(r => {
        if (r.status === 200) {
          // console.log(r)
        }
      });
    },
    postNewParcel() {
      if (!this.selectedParcel.geometry) {
        this.$root.$emit('showSnackbar', this.$i18n.t('parcels.requiredGeometry'));
        this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
        this.isEdited = false;
        window.onbeforeunload = null;
        return;
      }
      this.$store.dispatch('postNewParcel', this.preparePayload()).then(res => {
        if (res.status === 201) {
          this.$router.push({
            name: 'parcel',
            params: {
              id: res.data.parcels
            }
          });
          this.$store.commit('setNewlyAddedParcel', res.data.parcels);
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.parcels.save201'));
        } else if (res.status === 409) {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.parcels.errorExist'));
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.parcels.errorDB'));
        }
      });
    },
    editParcel() {
      if (!this.selectedParcel.geometry) {
        this.$root.$emit('showSnackbar', this.$i18n.t('parcels.requiredGeometry'));
        return;
      }
      this.$store.dispatch('editParcel', this.preparePayload()).then(r => {
        if (r.status === 200) {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.parcels.edit200'));
          this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
          this.isEdited = false;
          window.onbeforeunload = null;
        } else {
          this.$root.$emit('showSnackbar', this.$i18n.t('offer.parcels.errorDB'));
        }
      });
    },
    showLegend() {
      this.isLegendVisible = true;
      this.isLegendLoaded = true;
    },
    preparePayload() {
      const payload = {};
      this.flatProperties.cena_m.value = this.pricePLNM;
      if (Array.isArray(this.flatProperties.kontakt_cbre.value)) {
        this.flatProperties.kontakt_cbre.value = this.flatProperties.kontakt_cbre.value.join(',');
      }
      for (let group in this.attributes) {
        this.attributes[group].forEach(attribute => {
          payload[attribute.name] = attribute.value;
        });
      }
      payload.geometria = this.selectedParcel.geometry;
      if (!this.isNewEntity) {
        payload.id = this.entityID;
      }
      return payload;
    },
    updateProperties(propertiesArray) {
      this.disableResetLocalization = true; // zablokowanie zerowania pól powiatu oraz gminy
      propertiesArray.forEach(prop => {
        this.updateProperty(prop);
      });
      this.$nextTick(() => {
        this.disableResetLocalization = false; // odblokowanie zerowania pól powiatu oraz gminy
        this.isNewEntity ? this.postNewParcel() : this.editParcel();
      });
    },
    updateProperty({ name, value }) {
      this.flatProperties[name].value = value;
    },
    getProperty(group, name) {
      const attribute = this.attributes[group].find(attr => attr.name === name);
      return attribute.value;
    },
    updateGeometry(geometry) {
      this.selectedParcel.geometry = geometry;
      this.$nextTick(() => {
        this.$refs.map.zoomToGeometry(geometry);
      });
    },
    init() {
      if (this.isNewEntity) {
        if (this.$store.getters.getNewParcel === undefined) {
          this.$router.push('/parcels');
          return;
        }
        this.selectedParcel = this.$store.getters.getNewParcel;
        this.$store.dispatch('getParcel', { id: 'schema' }).then(r => {
          if (r.status === 200) {
            this.attributes = r.data.data;
            this.canEdit = true;
            for (let group in this.attributes) {
              for (let i = 0; i < this.attributes[group].length; i++) {
                if (this.attributes[group][i].translate && this.attributes[group][i].type !== 'multiselect') {
                  this.$set(this.attributes[group][i], 'value', {
                    pl: null,
                    en: null
                  });
                } else {
                  this.$set(this.attributes[group][i], 'value', null);
                }
              }
            }
            for (let property in this.selectedParcel) {
              if (property !== 'geometry') {
                for (let attributeGroup in this.attributes) {
                  const attribute = this.attributes[attributeGroup].find(attr => attr.name === property);
                  if (attribute) {
                    attribute.value = this.selectedParcel[property];
                    continue;
                  }
                }
              }
            }
            this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
            this.isReady = true;
          }
        });
      } else {
        this.$store
          .dispatch('getParcel', { id: this.entityID })
          .then(r => {
            if (r.status === 200) {
              this.attributes = r.data.parcels;
              const geometria = this.attributes.geometria;
              delete this.attributes.geometria;
              this.selectedParcel = {
                ...geometria,
                id: this.entityID
              };
              for (const flatProperty in this.flatProperties) {
                this.selectedParcel[flatProperty] = this.flatProperties[flatProperty].value;
              }
              this.canEdit = true;
              this.tableLoading = false;
              this.recalculatePrices();
              this.attributesCopy = JSON.parse(JSON.stringify(this.flatProperties));
              this.isReady = true;
            }
          })
          .catch(e => {
            console.error(e);
            this.$root.$emit('showSnackbar', e);
            this.$router.push('/parcels');
          });
      }
    },
    confirmExit() {
      this.$router.push(this.confirmExitTo);
    }
  },
  watch: {
    attributes: {
      handler() {
        this.isEdited = JSON.stringify(this.flatProperties) !== JSON.stringify(this.attributesCopy);
        if (this.isEdited) {
          window.onbeforeunload = () => {
            return '';
          };
        } else {
          window.onbeforeunload = null;
        }
      },
      deep: true
    }
  },
  created() {
    this.floatRule = v => /([0-9]+([.][0-9]+)?)/.test(v) || this.$i18n.t('default.mustBeNumber');
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdited && !this.isConfirmExitVisible) {
      this.confirmExitTo = to;
      this.isConfirmExitVisible = true;
    } else {
      next();
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  beforeMount() {
    window.onbeforeunload = () => {
      return '';
    };
  },
  mounted() {
    this.$root.$on('changeIsEdited', value => (this.isEdited = value));
    this.init();
    this.$store.dispatch('fetchUsers');
  }
};
</script>
<style lang="scss">
html {
  overflow: auto;
}
.expansion__panel--table {
  height: 300px;
}
.invisible {
  display: none;
}
.table {
  height: 100%;
}
.attributes {
  height: calc(100% - 65px);
  overflow-y: auto;
}
div.v-data-table__wrapper.vb-content {
  height: inherit !important;
}
.table__row--tools {
  text-align: center;
}
// th .v-icon {
//   display: none;
// }
#table-parcels > div.v-data-table__wrapper.vb-content > table > thead > tr > th.text-center {
  display: flex;
  justify-content: center;
  align-items: self-start;
  box-shadow: none;
}
::-webkit-scrollbar {
  width: 7px;
}
input:invalid {
  border: 1px solid #ff0000;
}
::-webkit-scrollbar:hover ::-webkit-scrollbar {
  width: 12px;
}
::-webkit-scrollbar-thumb {
  background-color: rgba($primary-color, 0.2);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgba($primary-color, 0.5);
  width: 12px;
}
.btn--add {
  position: absolute;
  right: 12px;
  top: 12px;
}
.btn--phone {
  position: absolute;
  right: 60px;
  top: 12px;
}
</style>
